import NoticeSlide from "./NoticeSlide";
import ViewToggleBtn from "./ViewToggleBtn";
import "./TopBar.scoped.scss";

function TopBar() {
  return (
    <div className="notice-frame">
      <NoticeSlide />
      <ViewToggleBtn />
    </div>
  );
}

export default TopBar;
